import { render, staticRenderFns } from "./ManageBaseTableSortMenu.vue?vue&type=template&id=0c1acb83&"
import script from "./ManageBaseTableSortMenu.vue?vue&type=script&lang=js&"
export * from "./ManageBaseTableSortMenu.vue?vue&type=script&lang=js&"
import style0 from "./ManageBaseTableSortMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
